import { render, staticRenderFns } from "./ProjectIndex.vue?vue&type=template&id=35fc969d&scoped=true&"
import script from "./ProjectIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProjectIndex.vue?vue&type=style&index=0&id=35fc969d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc969d",
  null
  
)

export default component.exports